const internalSiteDelivery = (state = true, action) => {
    switch(action.type) {
        case 'internalSiteDelivery':
            return action.payload;
        default:
            return state;
    }
}

export default internalSiteDelivery;